import { memo } from 'react'

interface Props {
  maskId: string
  maskWidth: number
  color: string
  height?: number
  width?: number
}

function StarRating(props: Props) {
  const { color, maskWidth, maskId, width = 123, height = 24 } = props
  return (
    <svg width={`${width}px`} height={`${height}px`} viewBox="0 0 123 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
        <defs>
          <path d="M98.3504866,8.85316873 L107.659,8.85316873 L110.535672,0 L113.412344,8.85316873 L122.720969,8.85316873 L115.189984,14.3248925 L118.066433,23.1778381 L110.535672,17.7063375 L103.004688,23.1778381 L105.881359,14.3248925 L98.3503751,8.85316873 L89.0419732,8.85316873 L86.1653015,0 L83.2886297,8.85316873 L73.9801163,8.85316873 L66.4492436,14.3248925 L69.3256922,23.1778381 L61.7949311,17.7063375 L54.2639468,23.1778381 L57.1406186,14.3248925 L49.6097459,8.8532498 L42.0788732,14.3248925 L44.9553218,23.1778381 L37.4245607,17.7063375 L29.8935765,23.1778381 L32.7702482,14.3248925 L25.239264,8.85316873 L34.547889,8.85316873 L37.4245607,0 L40.3012325,8.85316873 L49.6098575,8.85316873 L58.9182593,8.85316873 L61.7949311,0 L64.6716028,8.85316873 L73.9801163,8.85316873 L81.5109889,14.3248925 L78.6343172,23.1778381 L86.1653015,17.7063375 L93.6960626,23.1778381 L90.819614,14.3248925 L98.3505982,8.85316873 Z M13.0539672,0 L15.9306389,8.85316873 L25.239264,8.85316873 L17.7082797,14.3248925 L20.5847283,23.1778381 L13.0539672,17.7063375 L5.52298294,23.1778381 L8.39965468,14.3248925 L0.868670428,8.85316873 L10.1772954,8.85316873 L13.0539672,0 Z" id="path-1"></path>
        </defs>
      </defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-7">
          <mask id={maskId} fill="white">
            <use href="#path-1"></use>
          </mask>
          <use id="Combined-Shape" fill="#E6E6E6" href="#path-1"></use>
          <rect id="Rectangle" fill={color} mask={`url(#${maskId})`} x="-6.96296296" y="-6.96296296" width={maskWidth} height="36.5555556"></rect>
        </g>
      </g>
    </svg>
  )
}

export default memo<Props>(StarRating)
